
import { Component, Mixins, Emit } from "vue-property-decorator";
import { CommonTabMixin } from ".";
import { ReceptionApplicant, ReceptionRecipient, ReceptionContact, ReceptionDelivery, ReceptionPatient } from "../../../../../domain/workflow/reception";
import { ButtonInfo } from "../../../../../domain/workflow/items";
import { ReceptionCreateKinds } from "../../../../../domain/workflow/kinds";
import { DomainRegistry } from "../../../../../domain";

@Component({
})
export default class ReceptionTabMixin extends Mixins(CommonTabMixin) {
  
  @Emit()
  delete(): void {}

  // --------------プロパティ-------------------------------

  get patient(): ReceptionPatient {
    return this.reference ? this.reference.reception.patientInfo : null;
  }

  get applicant(): ReceptionApplicant {
    return this.reception ? this.reception.applicant : null;
  }

  get recipient(): ReceptionRecipient {
    return this.reception ? this.reception.recipient : null;
  }

  get contact(): ReceptionContact {
    return this.reception ? this.reception.contact : null;
  }

  get delivery(): ReceptionDelivery {
    return this.reception ? this.reception.delivery : null;
  }

  get deliveryLimitDate(): Date {
    return this.workflow ? this.workflow.deliveryLimitDate : null;
  }

  get workflowStatusName(): string {
    return this.workflow ? this.workflow.status.waitName : null;
  }

  // 削除理由
  get deleteMessagePermission(): ButtonInfo {
    return this.permissions ? this.permissions.deleteMessage : null;
  }

  get permittedDeleteMessage(): boolean {
    return this.deleteMessagePermission ? this.deleteMessagePermission.isPermitted : false;
  }

  // --------------依頼詳細用ボタン------------------------

  get editDetailPermission(): ButtonInfo {
    return this.permissions ? this.permissions.edit : null;
  }

  get permittedEditDetail(): boolean {
    return this.editDetailPermission ? this.editDetailPermission.isPermitted : false;
  }

  get deleteDetailPermission(): ButtonInfo {
    return this.permissions ? this.permissions.delete : null;
  }

  get permittedDeleteDetail(): boolean {
    return this.deleteDetailPermission ? this.deleteDetailPermission.isPermitted : false;
  }

  get cancelDetailPermission(): ButtonInfo {
    return this.permissions ? this.permissions.cancel : null;
  }

  get permittedCancelDetail(): boolean {
    return this.cancelDetailPermission ? this.cancelDetailPermission.isPermitted : false;
  }

  get returnDetailPermission(): ButtonInfo {
    return this.permissions ? this.permissions.return : null;
  }

  get permittedReturnDetail(): boolean {
    return this.returnDetailPermission ? this.returnDetailPermission.isPermitted : false;
  }

  get quoteDetailPermission(): ButtonInfo {
    return this.permissions ? this.permissions.quote : null;
  }
  
  get permittedQuoteDetail(): boolean {
    return this.quoteDetailPermission ? this.quoteDetailPermission.isPermitted : false;
  }

  get copyDetailPermission(): ButtonInfo {
    return this.permissions ? this.permissions.copy : null;
  }

  get permittedCopyDetail(): boolean {
    return this.copyDetailPermission ? this.copyDetailPermission.isPermitted : false;
  }

  get publishReceiptPermission(): ButtonInfo {
    return this.permissions ? this.permissions.publishReceipt : null;
  }

  get permittedPublishReceipt(): boolean {
    return this.publishReceiptPermission ? this.publishReceiptPermission.isPermitted : false;
  }

  // ------------メソッド ---------------------------

  // 依頼編集
  editDetail(): void {
    this.openEditDetail(this.receptionDetailId);
  }

  openEditDetail(detailId: number): void {
    const param: any = {
      receptionDetailId: detailId
    };
    this.$openWindow("/EditReceptionDetail", param);
  }

  async execDeleteDetail(deleteMessage: string): Promise<void> {
    const repository = DomainRegistry.workflow.getWorkflowRepository();
    try {
      this.startLoading();
      const result = await repository.deleteReceptionDetail(this.reference.receptionDetail.id, deleteMessage);
      this.stopLoading();
      if (result.success) {
        this.$success("依頼削除", "依頼の削除に成功しました。");
        // 親に投げる
        this.delete();
      } else {
        this.$error("依頼削除エラー", result.message + "\n" + result.reason);
      }
    } catch (e) {
      this.stopLoading();
      this.showRequestErrorMessage("依頼削除エラー", "依頼の削除に失敗しました。", e);
    }
  }

  // 依頼引用
  quoteDetail(): void {
    const param: any = {
      createKind: ReceptionCreateKinds.QuoteDetail,
      sourceReceptionDetailId: this.receptionDetailId,
      isUnmanaged: this.isUnmanaged,
    };
    this.$openWindow("/NewReception", param);
  }

  // 依頼コピー
  copyDetail(): void {
    const param: any = {
      createKind: ReceptionCreateKinds.CopyDetail,
      sourceReceptionDetailId: this.receptionDetailId
    };
    this.$openWindow("/NewReception", param);
  }

  // 受領書再発行
  async publishReceipt(): Promise<void> {
    const name = this.publishReceiptPermission.buttonName;
    try {
      if (this.receiptFormatOriginalIds.length !== 0) {
        // Assistant経由でフォーマットデータから文書データを生成して印刷（登録はしない）
        // receiptFormatOriginalIdsは複数持てるようにはしているが、現状では先頭ひとつのみ対応している
        // TODO: いったん文書参照画面を挟むのもアリな気がする
        const service = DomainRegistry.localhost.getApplicationService();
        service.publishReceiptWithSpecifiedFormat(
          this.$store.getters.user.id,
          this.$store.getters.department.id,
          this.reception.patientInfo.patient.id,
          this.reception.id,
          this.receiptFormatOriginalIds[0],
          true);
      } else {
        // ReceiptPublish起動
        const service = DomainRegistry.localhost.getApplicationService();
        service.launchDetailReceiptPublish(this.reception.id, this.receptionDetailId);
      }
    } catch (e) {
      this.$error(
        name + "失敗"
        , name + "ができませんでした。");
      console.error(e);
    }
  }
}
